import React, { useState, useEffect } from "react";
import "./AtplSelectType.css";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";

export default function AtplSelectType() {
  const [accepted, setAccepted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [teamType, setTeamType] = useState("");
  const navigate = useNavigate();

  const handleNavigation = (sport, teamType, userId) => {
    if (sport === "Cricket" && teamType === "Team") {
      navigate(`/AtplMensForm/${userId}`);
    } else if (sport === "Cricket" && teamType === "Individual") {
      navigate(`/Atplmensindividual/${userId}`);
    } else {
      navigate("/", { replace: true });
    }
  };

  const handleProceed = async () => {
    if (!teamType) {
      return Swal.fire({
        icon: "info",
        title: "Participation Type Missing",
        text: "Please select a Participation type: Individual or Team!",
        timer: 3000,
        showConfirmButton: false,
      });
    }
    if (!accepted) {
      return Swal.fire({
        icon: "warning",
        title: "Terms & Conditions",
        text: "You must accept the Terms & Conditions to proceed!",
        timer: 3000,
        showConfirmButton: false,
      });
    }


    try {
      Swal.fire({
        title: "Please wait",
        text: "Processing your selection...",
        allowOutsideClick: false,
        showConfirmButton: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });

      const res = await fetch("https://node.aattumtpl.com/api/event/register", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          teamType,
          termsAccepted: accepted,
        }),
      });

      const text = await res.text();
      let data;
      try {
        data = JSON.parse(text);
      } catch (err) {
        Swal.close();
        return Swal.fire({
          icon: "error",
          title: "Invalid Response",
          text: "Server returned unexpected data.",
        });
      }

      Swal.close();

      if (res.ok && data.success) {
        const userId = data.userId;
        // 💾 Save to Local Storage
        localStorage.setItem("userId", userId);

        Swal.fire({
          icon: "success",
          title: "Selection Confirmed",
          html: `
          <p>Your User ID: <b>${userId}</b></p>
          <p>Proceeding to ${teamType} Registration</p>
        `,
          customClass: {
            popup: "swal-popup-custom"
          },
          showConfirmButton: false,
          timer: 2500,
        });


        handleNavigation("Cricket", teamType, userId);
        window.scrollTo(0, 0);
      } else {
        Swal.fire({
          icon: "error",
          title: "Unable to proceed",
          text: data.error || "Please try again later.",
        });
      }
    } catch (err) {
      Swal.close();
      Swal.fire({
        icon: "error",
        title: "Server Error",
        text: "Please check your connection and try again.",
      });
    }

  };

  return (
    <div className="sportselect-outerRL">
      <div className="sportselect-pageRL">
        <div className="sportselect-headerRL">
          <img
            src="/Images/cricket menbanner.png"
            alt="Sports Banner"
            className="sportselect-bannerRL"
          />
        </div>
        <div className="sportselect-topRL">
          <h2 className="sportselect-headingRL">ATPL MEN’S T-20 CHAMPIONSHIP.</h2>
          <p className="sportselect-subheadingRL">
            Register your team today to confirm entry and secure a spot in the exciting upcoming tournament.
          </p>

          <div className="sportselect-row23RL">
            <label className="sportselect-labelRL">Participation Type :</label>
            <select
              value={teamType}
              onChange={(e) => setTeamType(e.target.value)}
              className="sportselect-dropdownRL"
            >
              <option value="">-- Select --</option>
              <option value="Individual">Individual</option>
              <option value="Team">Team</option>
            </select>
          </div>

          <div className="sportselect-agreementRL">
            <h3>Terms & Conditions</h3>
            <ul>
              <li>All players must arrive at least 15 minutes before the match starts.</li>
              <li>Proper sports attire is mandatory during the tournament.</li>
              <li>Decisions made by referees/officials are final and must be respected.</li>
              <li>Any misconduct, abusive language, or unfair play may result in disqualification.</li>
              <li>The organizers are not responsible for personal injuries or loss of belongings.</li>
              <li>By registering, you confirm that you are physically fit to participate.</li>
            </ul>

            <p>
              The tournament committee reserves the right to modify the schedule or
              format of matches in case of unforeseen circumstances, such as weather
              conditions or venue availability. Players are expected to stay updated
              through official communication channels.
            </p>
            <p>
              All participants are expected to uphold the spirit of sportsmanship and
              camaraderie throughout the event. Any disputes or grievances should be
              reported directly to the organizing committee, whose decision will be
              considered final and binding.
            </p>

            <p>
              By joining this event, you acknowledge that participation is entirely
              voluntary and at your own risk. You also grant permission to the
              organizers to use photos or videos captured during the event for
              promotional purposes without any compensation.
            </p>

            <div className="sportselect-agreecheckRL">
              <input
                type="checkbox"
                id="termsRL"
                checked={accepted}
                onChange={(e) => setAccepted(e.target.checked)}
              />
              <label htmlFor="termsRL">
                I have read and accept the Terms & Conditions
              </label>
            </div>
          </div>
          <div className="sportselect-btn-containerRL">
            <button
              className="sportselect-back-buttonRL"
              onClick={() => {
                navigate("/");
                window.scrollTo(0, 0);
              }}
            >
              Back
            </button>
            <button
              className="sportselect-buttonRL"
              onClick={handleProceed}
              disabled={loading}
            >
              {loading ? "Processing..." : "Proceed"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
